import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 奇优影院免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>

        {movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50">
            新上线
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50">
            热门
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-1 text-xs text-primary-400">
            <i className="ri-star-fill text-xs"></i>
            <span>{movie.rating}</span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-800 truncate group-hover:text-primary-500 transition-colors duration-200">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-600">·</span>
          <span className="text-xs text-foreground-500">{movie.category}</span>
        </div>
      </div>
    </Link>
  );
}